import React, { Component } from 'react';

export class AppFooter extends Component {

    render() {
        return  (
            <div className="layout-footer">
                {/* <span className="footer-text" style={{'marginRight': '5px'}}><a href="https://www.apco-coating.com/">Copyright © 2024 -Arabian Pipe Coating Company - APCO</a> </span> */}
                {/* <img src="assets/layout/images/logo.svg" alt="" width="80"/> */}
                <span className="footer-text" style={{'marginLeft': '5px',float:'right'}}> <a href="http://www.firstonesystems.com">Powered by FirstOne Softwares Pvt, Ltd.</a>, India.[V: 4.0] </span>
            </div>
        );
    }
}